import { render, staticRenderFns } from "./docSettings.vue?vue&type=template&id=49804571"
import script from "./docSettings.vue?vue&type=script&lang=js"
export * from "./docSettings.vue?vue&type=script&lang=js"
import style0 from "./docSettings.vue?vue&type=style&index=0&id=49804571&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports